<script setup lang="ts">
/**
 * Custom icon — NOT part of the FluentUI set.
 * Dashed variant of EyeIcon.vue, hand-built for the "visible on show-more"
 * toggle state (default hidden, but displayable on demand).
 *
 * The original EyeIcon paths are fills, which cannot be dashed. The eye is
 * therefore redrawn as a stroked centerline (same geometry) so `stroke-dasharray`
 * applies. Keep the geometry in sync with EyeIcon.vue if that icon changes.
 */
const props = withDefaults(defineProps<{ filled?: boolean; size?: string; color?: string }>(), {
  filled: false,
  size: undefined,
  color: undefined,
});
</script>

<template>
  <svg
    v-if="filled"
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.26 11.6A6.97 6.97 0 0 1 10 6c3.2 0 6.06 2.33 6.74 5.6"
      fill="none"
      stroke="currentColor"
      stroke-width="1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-dasharray="1.8 1.7"
    />
    <circle
      cx="10"
      cy="11.5"
      r="3"
      fill="none"
      stroke="currentColor"
      stroke-width="1"
      stroke-linecap="round"
      stroke-dasharray="1.8 1.7"
    />
    <circle cx="10" cy="11.5" r="1" fill="currentColor" />
  </svg>
  <svg
    v-else
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.26 11.6A6.97 6.97 0 0 1 10 6c3.2 0 6.06 2.33 6.74 5.6"
      fill="none"
      stroke="currentColor"
      stroke-width="1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-dasharray="1.8 1.7"
    />
    <circle
      cx="10"
      cy="11.5"
      r="3"
      fill="none"
      stroke="currentColor"
      stroke-width="1"
      stroke-linecap="round"
      stroke-dasharray="1.8 1.7"
    />
  </svg>
</template>
